import { toObjectMap } from "@@/utilities/dictionary";
import type { Percentage} from "../percentage";
import { percentageZodSchema } from "../percentage";

const vatRatesSweden = [
    0 as Percentage,
    0.06 as Percentage,
    0.12 as Percentage,
    0.25 as Percentage,
] as const;
type VatRateSweden = (typeof vatRatesSweden)[number];
const vatRateSwedenMap = toObjectMap<VatRateSweden>([...vatRatesSweden]);

const swedishVatZodSchema = percentageZodSchema.refine(value =>
    vatRatesSweden.includes(value),
); //as unknown as z.ZodSchema<Percentage>;

const isSwedishVat = (vat: Percentage): vat is VatRateSweden =>
    vatRatesSweden.includes(vat);

export { isSwedishVat, swedishVatZodSchema, vatRatesSweden, vatRateSwedenMap };
export type { VatRateSweden };
